
import { INotice, NoticePriority } from "@/store/notice-store";
import { Component, Prop, Vue } from "vue-property-decorator";
import NoticePassengers from '@/components/Notices/NoticePassengers.vue';
import NoticeTitle from '@/components/Notices/NoticeTitle.vue';
import { RawLocation } from 'vue-router';

@Component({
  components: {
    NoticePassengers,
    NoticeTitle,
  },
})
export default class NoticeListItem extends Vue {
  @Prop({ required: true }) notice!: INotice;

  get titleId() {
    return `notice-title-${this.notice.id}`;
  }

  get descriptionId() {
    return `notice-description-${this.notice.id}`;
  }

  get openNoticeAriaLabel() {
    return `${this.$t('notices.open-notice')}: ${this.notice.title}`;
  }

  get backgroundColor() {
    if (this.notice.priority === NoticePriority.Sticky) {
      return 'grey lighten-4';
    }
    return '';
  }

  get noticeLocation(): RawLocation {
    const route: RawLocation = { name: 'notice', params: { id: this.notice.id } };

    if (this.$route.query.passengerId) {
      route.query = { passengerId: this.$route.query.passengerId };
    }

    return route;
  }

}
